<template>
  <div class="page">
    <div class="container-fluid pt-2 contenu-page">
      <div class="container bg-verifavis p-3">
        <Conformite nomImage="ko.png" resultatConformite="La référence de l’avis qui a été saisie ne correspond pas à celle du dernier avis connu pour cet usager, pour le millésime concerné" libelleConformite="" messageAide="Les références saisies ne permettent pas d'identifier un avis présent dans la base de la DGFiP. Veuillez vérifier votre saisie. La situation peut également avoir changé et l'avis ne correspond pas à la situation la plus récente pour le millésime concerné." />
        <br /> 
        <div class="d-flex justify-content-end align-items-center">
            <div class="p-3">
              <button class="btn btn-retour me-2" type="button" @click="$router.back()">Retour à l'étape précédente</button>
            </div>
        </div>
      </div>
    </div>
    <div class="bas-page">© Ministère de l'Économie, des Finances et de la Souveraineté industrielle et numérique</div>
  </div>
</template>

<script>
import Conformite from "@/components/Conformite/Conformite.vue";

/**
 * Page avis non conforme
 * 
 * @author <span><span class="fw-bold">Inconnu</span><a class="ms-2" href="mailto:inconnu@dgfip.finances.gouv.fr">inconnu@dgfip.finances.gouv.fr</a></span>
 * @since <span class="fw-bold">Version 1.0</span>
 * @displayName AvisNonConforme
 */
export default {
name: "AvisNonConforme",
components: {
   Conformite
  },
 data () {
    return {
      aide: false
    }
  },
  created () {
    // recuperer les donnees lorsque la vue est creee et
    // que les donnees sont deja observees
    this.fetchData()
  },
  watch: {
    // appeler encore la methode si la route change
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      if(this.$route.params === undefined || this.$route.params.codeReponse === undefined)
      {
        this.$router.push({ name: 'VerifAvis2'});
      }
      
    }
  }
};
</script>